export default {
  placeholder: '請輸入內容',
  insertImage: '插入圖片',
  insertVideo: '插入影片',
};
